/* jshint browser: true, strict: false, maxlen: false, maxstatements: false */
(function () {
  function warn() {
    if (window.console && window.console.warn) {
      window.console.warn.apply(window.console, arguments);
    }
  }

  if (window.bitpay) {
    warn('bitpay.js attempted to initialize more than once.');
    return;
  }

  var iframe = document.createElement('iframe');
  iframe.name = 'bitpay';
  iframe.class = 'bitpay';
  iframe.setAttribute('allowtransparency', 'true');
  iframe.style.display = 'none';
  iframe.style.border = 0;
  iframe.style.position = 'fixed';
  iframe.style.top = 0;
  iframe.style.left = 0;
  iframe.style.height = '100%';
  iframe.style.width = '100%';
  iframe.style.zIndex = '2147483647';

  var origin = 'https://bitpay.com';
  var onModalWillEnterMethod = function () {};
  var onModalWillLeaveMethod = function () {};
  var ChildWindowRef;

  function showFrame() {
    document.body.style.overflow = 'hidden';
    if (window.document.getElementsByName('bitpay').length === 0) {
      window.document.body.appendChild(iframe);
    }
    onModalWillEnterMethod();
    iframe.style.display = 'block';
  }

  function hideFrame() {
    onModalWillLeaveMethod();
    iframe.style.display = 'none';
    iframe = window.document.body.removeChild(iframe);
    document.body.style.overflow = 'auto';
    // Close and remove ChildWindowRef if it exists
    if (ChildWindowRef && !ChildWindowRef.closed) {
      ChildWindowRef.close();
    }
    ChildWindowRef = null;
  }

  function onModalWillEnter(customOnModalWillEnter) {
    onModalWillEnterMethod = customOnModalWillEnter;
  }

  function onModalWillLeave(customOnModalWillLeave) {
    onModalWillLeaveMethod = customOnModalWillLeave;
  }

  function receiveMessage(event) {
    var uri;

    if (origin !== event.origin) {
      return;
    }

    // Unwrap modal2 messages
    var message = event.data;
    var isFromModal2 = event.data && event.data.from === 'modal2';
    // messages coming from modal2 have to be unwrapped
    if (isFromModal2) {
      message = event.data.message;
    }

    if (message === 'close') {
      hideFrame();
    } else if (message === 'loaded' && isFromModal2) {
      // Only trigger showFrame for wrapped modal2 messages to prevent duplicate onModalWillEnter calls
      showFrame();
    } else if (message && message.open) {
      uri = message.open;
      if (
        uri.indexOf('bitcoin:') === 0 ||
        uri.indexOf('bitcoincash:') === 0 ||
        uri.indexOf('ethereum:') === 0 ||
        uri.indexOf('ripple:') === 0 ||
        uri.indexOf('bitpay:') === 0 ||
        uri.indexOf('copay:') === 0
      ) {
        event.preventDefault();
        if (message.mobile) {
          window.location.href = uri;
          return;
        }
        var iframe = document.createElement('iframe');
        iframe.src = uri;
        document.head.appendChild(iframe);
        setTimeout(function () {
          iframe.parentNode.removeChild(iframe);
        }, 100);
      }
    } else if (message && message.mailto) {
      uri = message.mailto;
      if (uri.indexOf('mailto:') === 0) {
        window.location = uri;
      }
    }
  }

  function showInvoice(invoiceId, params) {
    document.body.style.overflow = 'hidden';
    window.document.body.appendChild(iframe);
    var invoiceUrl = origin + '/invoice?id=' + invoiceId + '&source=bpjs';

    invoiceUrl += '&v=4';

    if (params && params.animateEntrance === false) {
      invoiceUrl += '&animateEntrance=false';
    }



    iframe.src = origin;

    var windowParams = 'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=700,height=900';
    // the popup window needs to have view=modal2 in order to properly exit
    ChildWindowRef = window.open(invoiceUrl + '&view=modal2', 'invoice', windowParams);
    // the frame needs to have view=modal
    invoiceUrl += '&view=modal';

    if (!ChildWindowRef || ChildWindowRef.closed || typeof ChildWindowRef.closed === 'undefined') {
      // Popup was blocked
      invoiceUrl += '&popupBlocked=true';
    }

    iframe.src = invoiceUrl;
  }

  function setApiUrlPrefix(urlPrefix) {
    origin = urlPrefix;
  }

  function enableTestMode(enable) {
    if (enable === false) {
      origin = 'https://bitpay.com';
      return;
    }
    origin = 'https://test.bitpay.com';
    warn('bitpay.js is running in test mode.');
  }

  function isLoadedFromBitPay() {
    var loadedFromBitPay = false;
    var scriptTags = window.document.getElementsByTagName('script');
    for (var i = 0; i < scriptTags.length; i++) {
      var tag = scriptTags[i];
      if (
        (tag.outerHTML && tag.outerHTML.indexOf && tag.outerHTML.indexOf('https://bitpay.com/bitpay.js') !== -1) ||
        tag.outerHTML.indexOf('https://bitpay.com/bitpay.min.js') !== -1
      ) {
        loadedFromBitPay = true;
      }
    }
    if (
      window.location.origin === 'https://bitpay.com' ||
      window.location.origin === 'https://test.bitpay.com' ||
      window.location.origin === origin
    ) {
      loadedFromBitPay = true;
    }
    return loadedFromBitPay;
  }

  function setButtonListeners() {
    var buttons = window.document.querySelectorAll('[data-bitpay-button]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[0];
      b.addEventListener('submit', showFrame);
    }
  }

  window.addEventListener('load', function load() {
    if (!isLoadedFromBitPay()) {
      warn(
        'bitpay.js: It looks like you may be loading bitpay.js in an unconvential way. We highly recommend that you load bitpay.js by adding \'<script src="https://bitpay.com/bitpay.min.js"></script>\' to your webpage. This will ensure that you get access to new features and product updates as they become available.'
      );
    }
    window.removeEventListener('load', load);
  });

  window.addEventListener('message', receiveMessage, false);
  setButtonListeners();

  window.bitpay = {
    showFrame: showFrame,
    hideFrame: hideFrame,
    showInvoice: showInvoice,
    onModalWillEnter: onModalWillEnter,
    onModalWillLeave: onModalWillLeave,
    enableTestMode: enableTestMode,
    setApiUrlPrefix: setApiUrlPrefix,
  };
})();


